import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ngx-question-header',
  templateUrl: './question-header.component.html',
  styleUrls: ['./question-header.component.scss']
})
export class QuestionHeaderComponent implements OnInit {

  @Output()
  typeChanged: EventEmitter<any> = new EventEmitter();

  type: string;

  controlsList = [{ key: 'TEXT', value: 'Réponse courte' },
        { key: 'TEXTAREA', value: 'Réponse longue' },
        { key: 'CALENDAR', value: 'Date' },
        { key: 'RADIO', value: 'Choix unique' },
        { key: 'CHECKBOX', value: 'Multi choix' },
        { key: 'SELECT', value: 'Liste déroulante' },
        { key: 'LINEARSCALE', value: 'Echelle linéaire' }];
  constructor() { }

  ngOnInit(): void {
  }


  onChangeType() {
    this.typeChanged.emit(this.type);
  }
}
